export default {
  login_mfa: {
    title: '@:login.title',
    message: 'ご登録の電話番号のSMSに認証コードをお送りしました。\n認証コードを入力し、ログインボタンを押してください。\n有効期限は5分間です。',
    button_submit: '@:login.login',
    button_resend: '認証コードを再送する',
    alert_success: '認証コードを再送しました。',
    alert_error: '認証コードの再送に失敗しました。',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'ログインしたユーザーに電話番号の登録がなかったため、SMS認証が実施できませんでした。\n\n貴社アカウント管理者に連絡して、電話番号の登録を依頼してください。',
  },
}
